define('super-user/super-user.module',['angular', './super-user.routes', './super-user.controllers', './super-user.services'], function(angular, routes, controllers) {
    'use strict';
    var mod = angular.module('com.cd.superUser', ['ngRoute', 'super-user.routes', 'super-user.services']);
    mod.controller('UserOrgsCtrl', controllers.UserOrgsCtrl);
    return mod;
});
